import 'jsrender';
import 'Utils/global';
import { modifyQueryString /*, getSearchParameters, getSearchQueryString*/ } from 'Utils/global';

/* jQuery plugin widgetSlickSlider
*  required: jQuery, jsRender, slick.js
*  
*  Documentation of jsRender API: https://www.jsviews.com/#jsrapi
*  Examples of jsRender: https://www.jsviews.com/#download/pages-jsr-jq
*  
*  Documentation of Slick settings: https://github.com/kenwheeler/slick/#settings
*  Live examples of Slick: http://kenwheeler.github.io/slick/
*/
(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original splice()

    //function GetBreakpointWidth() {
    //    //var bp_Width = $(window).width();
    //    var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    //    return bp_Width;
    //}

    //function GetBreakpointHeight() {
    //    //var bp_Height = $(window).height();
    //    var bp_Height = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
    //    return bp_Height;
    //}

    function useSlider() {
        //return GetBreakpointWidth() < 768;
        return true;
    }

    function update_slider(actionbox) {
        if (useSlider()) {
            methods.initSlider(actionbox);
        } else {
            methods.destroySlider(actionbox);
        }
    }

    function get_slider(actionbox) {
        var $slider = actionbox.$slider,
            slider = null;
        if ($slider.length > 0 && $slider[0].slick) {
            slider = $slider.slick('getSlick');
        } else {
            try {
                slider = $slider.slick('getSlick');
            } catch (e) {
                //console.warn(e);
            }
        }
        return slider;
    }

    function update_slides(actionbox) {
        var actionboxElement = actionbox.actionboxElement,
            $slider = actionbox.$slider,
            slider = get_slider(actionbox);

        var slidesSpacing = actionbox.sliderOptions.slidesSpacing || 0;
        var slidesToShow = actionbox.sliderOptions.slidesToShow || 1;
        var slidesFullWidth = actionbox.sliderOptions.slidesFullWidth || true;

        var responsive = actionbox.sliderOptions.responsive;
        if (responsive && responsive.length > 0) {
            slidesToShow = slider.options.slidesToShow;
            slidesSpacing = slider.options.slidesSpacing;
            slidesFullWidth = slider.options.slidesFullWidth;
        }

        var w = $slider.outerWidth() + slidesSpacing;
        var slide_w = (w / slidesToShow);
        if (slidesFullWidth === 0) {
            // like slidesFullWidth === true
        } else if (slidesFullWidth !== true && !isNaN(slidesFullWidth)) {
            let k = Math.abs(slidesFullWidth);
            k = k / 100;
            slide_w = slide_w * k;
            //actionboxElement
            //    .attr('data-k', k)
            //    .attr('data-slide_w', slide_w);
        }

        var $slides = actionboxElement.find('.' + actionbox.slideClassName);
        $slides.each(function (i) {
            let $slide = $(this);
            $slide.css('width', slide_w)
                .css('padding-left', slidesSpacing);
        });
        $slider.find('.slick-track').css('margin-left', -1 * slidesSpacing);
    }

    function update_slimmage() {
        if (window.slimmage.checkResponsiveImages) {
            window.slimmage.checkResponsiveImages();
        }

        if (typeof imgix !== "undefined") {
            imgix.init();
        }

        if (typeof lazySizes !== "undefined") {
            lazySizes.loader.checkElems();
        }
    }

    function requestData(actionbox) {
        if (!actionbox)
            return;

        if (!actionbox.request)
            actionbox.request = {};

        var jqxhr = actionbox.request.jqxhr;
        // cancel executing request before start new request 
        if (jqxhr) {
            if (typeof jqxhr.abort != "undefined")
                jqxhr.abort();
        }

        actionbox.request.requesting = true;
        actionbox.request.failed = false;
        actionbox.request.ready = false;

        var js = actionbox.request.parameters;
        var jsondata = JSON.stringify(js);

        jqxhr = $.ajax({
            url: actionbox.request.url,
            type: actionbox.request.type, //'POST',
            data: jsondata,
            contentType: 'application/json',
            headers: { 'Accept': 'application/json' },
            success: function (data) {
                if (data && data.Redirect && data.RedirectUrl != '') {
                    if (typeof ga != "undefined") {
                        ga('send', 'event', 'Basket ' + self.RequestType(), 'Redirected', self.GetRequestDetailsByParams());
                    }
                    //window.location.href = data.RedirectUrl;
                    window.location = data.RedirectUrl;
                    return;
                }

                var success = false;
                actionbox.request.data = data;
                if (!data || data.length == 0) {
                    actionbox.request.ready = false;
                    actionbox.request.failed = true;
                    actionbox.request.requesting = false;
                } else {
                    if (typeof data.Success != "undefined") {
                        success = data.Success; // use Success if this property exists
                    } else {
                        success = true; // keep previous logic-way
                    }
                    
                    actionbox.request.failed = false;
                    actionbox.request.ready = true;
                    actionbox.request.requesting = false;
                }
                if (success) {
                    updateDataItems(actionbox);
                    updateWithData(actionbox);
                    update_slider(actionbox);
                }

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(success);
            },
            error: function (data, textStatus, errorThrown) {
                actionbox.request.data = data;
                actionbox.request.ready = false;
                actionbox.request.failed = true;
                actionbox.request.requesting = false;

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(false);
            }
        }).always(function () {
            actionbox.request.jqxhr = null;
        });
        actionbox.request.jqxhr = jqxhr;
    }

    function updateDataItems(actionbox) {
        if (!actionbox.request.data.Items) return;
        if (!actionbox.update_data_item) return;
        if (typeof actionbox.update_data_item != "function") return;

        let newItems = actionbox.request.data.Items.map(function (item, index) {
            return actionbox.update_data_item(item, index, actionbox);
        });
        actionbox.request.data.Items = newItems;
    }

    function updateWithData(actionbox) {
        //console.log('updateWithData', actionbox);

        var actionboxElement = actionbox.actionboxElement,
            $slider = actionbox.$slider,
            $template = actionboxElement.find('[data-template="actionbox_item"]');

        var tmpl = $.templates($template.html());   // Get compiled template
        var data = actionbox.request.data.Items;    // Define data
        var html = tmpl.render(data);               // Render template using data - as HTML string
        $slider.html(html);                         // Insert HTML string into DOM
        actionbox.templates["actionbox_item"] = $template;
        $template.detach();

        $template = actionboxElement.find('[data-template="actionbox_action"]');
        if ($template.length > 0) {
            tmpl = $.templates($template.html());   // Get compiled template
            data = {};                              // Define data
            html = tmpl.render(data);               // Render template using data - as HTML string
            $(html).appendTo($slider);              // Insert HTML string into DOM
        }
        actionbox.templates["actionbox_action"] = $template;
        $template.detach();
    }


    var defaults = {
        className: 'is-actionbox-slider',
        elementClassName: 'action-box-slider',
        sliderClassName: 'slider',
        slideClassName: 'slide',
        holderClassName: 'holder',
        // Slick Slider options:
        sliderOptions: {
        },
        request: {
            url: '',
            type: 'GET',
            parameters: null,
            //jqxhr: null,
            //data: data,
            //ready: false,
            //failed: false,
            //requesting: false
        },
        update_data_item: function (item, index, actionbox) {
            return item;
        },
        templates: {},
        ga_event: '',
        ga_list_id: '',
        ga_list_name: '',
    },
        //$window = $(window),
        //$document = $(document),
        actionboxs = [],
        //scroller = function () {
        //    //console.log('actionbox-slider scroller()');
        //},
        resizer = function () {
            //console.log('actionbox-slider resizer()');
            for (var i = 0, l = actionboxs.length; i < l; i++) {
                var s = actionboxs[i];
                //update_slider(s);
                update_slides(s);
            }
            //update sidebar after resize
            //scroller();
        },
        methods = {
            init: function (options) {
                return this.each(function () {
                    var o = $.extend({}, defaults, options);
                    var actionboxElement = $(this);

                    let attr_ga_event = actionboxElement.attr('data-ga_event');
                    if (attr_ga_event && attr_ga_event.length > 0) {
                        o.ga_event = attr_ga_event;
                    }

                    let attr_ga_list_id = actionboxElement.attr('data-ga_list_id');
                    if (attr_ga_list_id && attr_ga_list_id.length > 0) {
                        o.ga_list_id = attr_ga_list_id;
                    }

                    let attr_ga_list_name = actionboxElement.attr('data-ga_list_name');
                    if (attr_ga_list_name && attr_ga_list_name.length > 0) {
                        o.ga_list_name = attr_ga_list_name;
                    }

                    var actionboxId = actionboxElement.attr('id');
                    var sliderId = actionboxId ? actionboxId + '-' + defaults.sliderClassName : defaults.sliderClassName;
                    var $slider = $('<div></div>')
                        .attr('id', sliderId)
                        .css('display', 'none')
                        .addClass(o.sliderClassName);
                    actionboxElement.prepend($slider);

                    //var wrapperId = sidebarId ? sidebarId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
                    var wrapperId = sliderId + '__wrapper';
                    o.wrapperClassName = o.sliderClassName + '__wrapper';
                    var wrapper = $('<div></div>')
                        .attr('id', wrapperId)
                        .addClass(o.wrapperClassName);
                    $slider.wrapAll(function () {
                        if ($(this).parent("#" + wrapperId).length == 0) {
                            return wrapper;
                        }
                    });

                    requestData(o);

                    o.actionboxElement = actionboxElement;
                    o.$slider = $slider;
                    actionboxs.push(o);
                });
            },
            initSlider: function (actionbox) {
                var actionboxElement = actionbox.actionboxElement,
                    $holder = actionboxElement.find('.' + actionbox.holderClassName),
                    $slider = actionbox.$slider,
                    slider = get_slider(actionbox);
                //$holder.hide();
                //$slider.show();
                if (!slider) {
                    var $slides = actionboxElement.find('.' + actionbox.slideClassName);
                    $slides.each(function (i) {
                        let $slide = $(this);
                        $slide.attr('data-abs-slide', i);
                        $slide.parent().attr('data-abs-ref-slide', i);
                    });

                    $slider.on('init', function (event, slick) {
                        // use setTimeout to execute when internal parameters are ready
                        setTimeout(function () {
                            slider = get_slider(actionbox);
                            update_slides(actionbox);

                            let maxIndex = null;
                            if (slider && slider.options && slider.options.slidesToShow) {
                                maxIndex = slider.options.slidesToShow;
                            }
                            let slidesUnveil = false;
                            if (slider && slider.options && slider.options.slidesUnveil) {
                                slidesUnveil = slider.options.slidesUnveil;
                            }
                            //console.log('maxIndex: ' + maxIndex);
                            let $slides = actionboxElement.find('.' + actionbox.slideClassName);
                            $slides.each(function (i) {
                                let $slide = $(this);
                                let $images = $slide.find('img, .lazyload');
                                if (!$images || $images.length < 1) {
                                    return;
                                }
                                $images.each(function (j, el) {
                                    if (el.hasClass('lazydefer')) {
                                        el.removeClass('lazydefer');
                                    }
                                    el.style.removeProperty('visibility');
                                    el.style.removeProperty('display');

                                    if (slidesUnveil && maxIndex !== null && i < maxIndex) {
                                        // NB!: index of slide
                                        lazySizes.loader.unveil(el);
                                    }
                                });
                            });

                            $holder.hide();
                            $slider.show();
                            actionbox.$holder = $holder;
                            $holder.detach();

                            update_slimmage();
                            update_slides(actionbox);
                        }, 128);
                    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        //console.log(nextSlide);
                    }).on('breakpoint', function (event, slick, breakpoint) {
                        //console.log(breakpoint);
                        update_slides(actionbox);
                    }).slick(actionbox.sliderOptions);
                }
            },
            //update: function () {
            //    scroller.apply(this, arguments);
            //},
            destroySlider: function (actionbox) {
                var actionboxElement = actionbox.actionboxElement,
                    $holder = actionboxElement.find('.' + actionbox.holderClassName),
                    $slider = actionbox.$slider,
                    slider = get_slider(actionbox);
                if ($holder.length < 1 && actionbox.$holder) {
                    $holder = actionbox.$holder;
                    $holder.appendTo(actionboxElement);
                }
                $slider.hide();
                $holder.show();
                if (slider) {
                    $slider.slick('unslick');
                    $slider.empty();
                }
            },
            destroy: function (options) {
                return this.each(function () {
                    var that = this;
                    var unactionboxElement = $(that);

                    var removeIdx = -1;
                    var i = actionboxs.length;
                    while (i-- > 0) {
                        if (actionboxs[i].actionboxElement.get(0) === that) {
                            methods.destroySlider(actionboxs[i]);
                            actionboxs[i].$slider.unwrap();
                            actionboxs[i].$slider.remove();
                            actionboxs[i].$slider = null;
                            actionboxs[i].$holder = null;
                            //actionboxs[i].templates = {};
                            unactionboxElement.removeClass(actionboxs[i].elementClassName);
                            splice.call(actionboxs, i, 1);
                            removeIdx = i;
                        }
                    }
                    if (removeIdx !== -1) {
                        // TODO smth with unactionboxElement styles on destroy
                        //unactionboxElement.unwrap();
                        //unactionboxElement.css({
                        //    'width': '',
                        //    'position': '',
                        //    'top': '',
                        //    'float': '',
                        //    'z-index': ''
                        //});
                    }
                });
            }
        };

    // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
    if (window.addEventListener) {
        //window.addEventListener('scroll', scroller, false);
        window.addEventListener('resize', resizer, false);
        window.addEventListener('focus', resizer, false);
    } else if (window.attachEvent) {
        //window.attachEvent('onscroll', scroller);
        window.attachEvent('onresize', resizer);
        window.attachEvent('onfocus', resizer);
    }

    $.fn.widgetSlickSlider = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on widgetSlickSlider');
        }
    };

    //$(function () {
    //    setTimeout(scroller, 0);
    //});
})(jQuery);


/*
widgetDestinationsSlider
*/
//AppLoader.ready(function () {
$(document).ready(function () {
    // added some timeout to give time for processing things with higher priorities.
    setTimeout(function () {
        if ($('.widgetDestinationsSlider').length > 0) {
            var c = 0;
            $('.widgetDestinationsSlider').each(function () {
                var $this = $(this);
                var id = $this.attr('id');
                if (!id || id == '') {
                    //$this.attr('id', 'widgetDestinationsSlider-' + c);
                    $this.attr('id', 'wds-' + c);
                    c++;
                }
            });

            let pageId = AppData.CurrentPageId;
            if (AppData.CurrentLandingPageId && AppData.CurrentLandingPageId > 0)
                pageId = AppData.CurrentLandingPageId;

            $('.widgetDestinationsSlider').widgetSlickSlider({
                sliderClassName: 'destinations-slider',         //'actionbox__slider',
                slideClassName:  'destinations-slider__slide',   //'actionbox__slide',           
                holderClassName: 'placeholder',                 //'actionbox__holder',
                // Slick Slider options:
                sliderOptions: {
                    arrows: true,
                    dots: false,
                    infinite: false,
                    prevArrow: '<div class="slick-prev" aria-label="Previous"></div>',
                    nextArrow: '<div class="slick-next" aria-label="Next"></div>',
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    swipe: true,
                    swipeToSlide: true,
                    speed: 600,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    slidesSpacing: 24, // custom settings
                    slidesFullWidth: true,  // custom settings
                    slidesUnveil: true, // custom settings
                    //centerMode: false,
                    variableWidth: true,
                    rows: 0,
                    respondTo: 'window',
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 0,
                        //settings: "unslick" // destroys slick
                        settings: {
                            arrows: false,
                            dots: true,
                            slidesToShow: 1,
                            //slidesSpacing: 0,
                            slidesFullWidth: 64.14,  // custom settings
                            //centerMode: true,
                        }
                    }, {
                        breakpoint: 480,
                        //settings: "unslick" // destroys slick
                        settings: {
                            arrows: false,
                            dots: true,
                            slidesToShow: 1,
                            //slidesSpacing: 0,
                            slidesFullWidth: 75,  // custom settings
                            //centerMode: true,
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            //slidesSpacing: 6,
                            slidesFullWidth: 100,
                            //dots: true
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            //slidesSpacing: 12,
                            slidesFullWidth: 100,
                            //infinite: true
                        }
                    }, {
                        breakpoint: 1280,
                        settings: {
                            //slidesToShow: 4,
                            //infinite: true
                        }
                    }]
                },
                request: {
                    url: '/widgets-api/destinationsSlider',
                    type: 'POST',
                    parameters: {
                        pageId: pageId
                    }
                },
                update_data_item: function (item, index, actionbox) {

                    let url = item.Url;

                    if (typeof url != "undefined") {
                        let queryString = '';

                        let list_id = actionbox.ga_list_id;
                        let list_name = actionbox.ga_list_name;

                        if (list_id && list_id != '') {
                            queryString = 'dl_ili=' + list_id;
                        }
                        if (list_name && list_name != '') {
                            queryString += (queryString != '' ? '&' : '') + 'dl_iln=' + list_name;
                        }

                        if (queryString && queryString != '') {
                            url = modifyQueryString(url, queryString, '');
                            item.Url = url;
                        }
                    }

                    return item;
                },
            });
        }
    }, 500);
});
//});

/*
widgetThemesSlider
*/
//AppLoader.ready(function () {
$(document).ready(function () {
    // added some timeout to give time for processing things with higher priorities.
    setTimeout(function () {
        if ($('.widgetThemesSlider').length > 0) {
            var c = 0;
            $('.widgetThemesSlider').each(function () {
                var $this = $(this);
                var id = $this.attr('id');
                if (!id || id == '') {
                    //$this.attr('id', 'widgetThemesSlider-' + c);
                    $this.attr('id', 'wts-' + c);
                    c++;
                }
            });
            $('.widgetThemesSlider').widgetSlickSlider({
                sliderClassName: 'themes-slider',           //'actionbox__slider',
                slideClassName:  'themes-slider__slide',    //'actionbox__slide',           
                holderClassName: 'placeholder',             //'actionbox__holder',
                // Slick Slider options:
                sliderOptions: {
                    dots: false,
                    infinite: false,
                    prevArrow: '<div class="slick-prev" aria-label="Previous"></div>',
                    nextArrow: '<div class="slick-next" aria-label="Next"></div>',
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    swipe: true,
                    swipeToSlide: true,
                    speed: 600,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    slidesSpacing: 24, // custom settings
                    variableWidth: true,
                    rows: 0,
                    respondTo: 'window',
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 0,
                        //settings: "unslick" // destroys slick
                        settings: {
                            slidesToShow: 1,
                            //slidesSpacing: 0,
                            //dots: true
                        }
                    }, {
                        breakpoint: 480,
                        //settings: "unslick" // destroys slick
                        settings: {
                            slidesToShow: 1,
                            //slidesSpacing: 0,
                            //dots: true
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            //slidesSpacing: 6,
                            //dots: true
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            //slidesSpacing: 12,
                            //infinite: true
                        }
                    }, {
                        breakpoint: 1280,
                        settings: {
                            //slidesToShow: 3,
                            //infinite: true
                        }
                    }]
                },
                request: {
                    url: '/widgets-api/themes',
                    type: 'POST',
                    parameters: {
                        pageId: AppData.CurrentPageId
                    }
                }
            });
        }
    }, 500);
});